import React, { forwardRef } from 'react';

import styled from 'styled-components';

import { ColContainer } from '../atoms';
import { SectionHeader, Session } from '../molecules';
import { ISection } from '../../entity/type';

const SectionContainer = styled(ColContainer)`
  width: 100%;

  @media (min-width: 800px) {
    max-width: 1024px;
  }
`;

const SessionsContainer = styled(ColContainer)`
  width: 100%;

  @media (min-width: 800px) {
    max-width: 1024px;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start;
  }
`;

interface SectionProps {
  section: ISection;
  sectionIndex: number;
}

function Section({
    section,
    sectionIndex,
  }: SectionProps,
  forwaredRef: React.Ref<HTMLDivElement>
) {
  return (
    <ColContainer
      w='100%'
      bg='#171819'
      style={{ padding: '16px 0px' }}
      id={section.id}
      ref={forwaredRef}
    >
      <SectionContainer>
        <SectionHeader
          icon={section.icon}
          name={section.name}
          title={section.title}
          desc={section.description}
          date={section.date}
          color={section.color}
        />
        <SessionsContainer>
          {section.sessions.map((v, i) => {
            return (
              <Session key={i} session={v} sessionId={`${sectionIndex}-${i}`} />
            );
          })}
        </SessionsContainer>
      </SectionContainer>
    </ColContainer>
  );
}

export default forwardRef(Section);
